<path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.7803 5.46967C12.0732 5.76256 12.0732 6.23744 11.7803 6.53033L8.31066 10L11.7803 13.4697C12.0732 13.7626 12.0732 14.2374 11.7803 14.5303C11.4874 14.8232 11.0126 14.8232 10.7197 14.5303L6.71967 10.5303C6.42678 10.2374 6.42678 9.76256 6.71967 9.46967L10.7197 5.46967C11.0126 5.17678 11.4874 5.17678 11.7803 5.46967Z"
    fill="currentColor"
/>
